import React, { useState, useEffect } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { ListSubheader } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import {
    setState
} from "../analyzeSlice";

const MultiSelectColumns = (props) => {
    const dispatch = useDispatch();
    const columnData = props?.columns;
    const columns = columnData?.map((item) => item.field);
    const [columnName, setcolumnName] = useState(columns);
    const [displayItem, setDisplayItem] = React.useState(columns.length-1);
    const [searchText, setSearchText] = React.useState("");
    const [namesData, setNamesData] = React.useState([]);
    const textInput = React.useRef(null);
    //const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const state = useSelector((store) => store.analyze);

    const {
        selectedColumns,
        fourPLData
    } = state;

    useEffect(()=>{
        setcolumnName(columns);
        setDisplayItem(columns.length-1);
    },[fourPLData])


    const handleChange  = (e, name) => {
        let items = [...columnName];
 
        if (e.target.checked) items.push(name);
        else {
        var index = items.indexOf(name);
        items.splice(index, 1);
        }
    
        setcolumnName(items);
    
        let itemcount = items.length-1;
        setDisplayItem(itemcount);
        if (itemcount == 0) setSelectAll(false);
        if (itemcount == columns.length) setSelectAll(true);
        else setSelectAll(false);
    };

    useEffect(() => {
        // Clear search text value
        setNamesData(columns);
    }, [columnData]);

    const handleDelete = (e, value) => {
        e.preventDefault();
        setcolumnName(columnName.filter((name) => name !== value));
    };

    const handleInputChange = (value) => {
        setSearchText(value);
    };

    const handleSelectAll = () => {
        if (!selectAll) {
          if (searchText) {
            let val = columns.filter((name) =>
              name.toLowerCase().includes(searchText.toLowerCase())
            );
            let item = [...columnName, ...val];
            const distinctArray = [...new Set(item)];
            setcolumnName(distinctArray);
            let itemcount = distinctArray.length - 1;
            setDisplayItem(itemcount);
          } else {
            setcolumnName(columns);
            let itemcount = columns.length - 1;
            setDisplayItem(itemcount);
          }
        } else {
          if (searchText) {
            let val = columns.filter((name) =>
              name.toLowerCase().includes(searchText.toLowerCase())
            );
            let item = [...columnName];
            item = item.filter((name) => !val.includes(name));
            const distinctArray = [...new Set(item)];
            setcolumnName(distinctArray);
    
            let itemcount = distinctArray.length - 1;
            setDisplayItem(itemcount);
          } else {
            setcolumnName([]);
          }
        }
        setSelectAll(!selectAll); 
    };
    useEffect(() => {
        let item = [...namesData];
        item = item.filter((name) => !columnName.includes(name));
        if(item.length == 0){
            setSelectAll(true);
        }else{
            setSelectAll(false);
        }
    }, [namesData]);
    // useEffect(() => {
    //     let itemcount = selectedOptions.length - 1;
    //     setDisplayItem(itemcount);
    // }, [selectedOptions])


    // useEffect(() => {
    //     if (selectAll) {
    //         let itemcount = namesData.length - 1;
    //         setcolumnName(columns);
    //         setDisplayItem(itemcount);
    //     }
    //     else {
    //         setcolumnName([]);
    //     }
    // }, [selectAll])

    console.log("ColumnName", columnName)
    console.log("namesData", namesData)


    useEffect(() => {
        //use a debounce to delay the search input key entry
        const delayDebounceFn = setTimeout(() => {
            if (searchText) {
                //filter options state using search text provided
                setNamesData((prevVal) => {
                    let val = columns.filter((name) => name.includes(searchText));

                    return val;
                });
            } else {
                setSearchText();
                setNamesData(columns);
            }

            //set focus on search text input field on load. setTimeOut is added as textInput is not immediately available
            setTimeout(() => {
                if (textInput.current) textInput.current.focus();
            }, 100);
        }, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [searchText]);

    //   const getcolumnIdsFromNames = (columnNames) => {
    //     const columnIds = columnNames.map((name) => {
    //       const column = columnData.find((option) => option.field === name);
    //       return column ? column.columnID : null;
    //     });
    //     return columnIds.filter((id) => id !== null);
    //   };

    useEffect(() => {
                dispatch(setState("selectedColumns", columnName))
    }, [columnName])


    //   console.log("all Ids", getcolumnIdsFromNames(selectedOptions));
    //   console.log("selected Ids", getcolumnIdsFromNames(columnName));

    return (
        <div>
            <FormControl sx={{ width: 300 }}>
                <InputLabel>Columns</InputLabel>
                <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    //fullWidth
                    sx={{ width: 500 }}
                    value={columnName}
                    //onChange={handleChange}
                    size="small"
                    input={<OutlinedInput label="MultiSelect" />}
                    renderValue={(selected) => (
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }} MenuProps>
                            {selected.map((value, index) => (
                                <div>
                                    {index < 1 ? (
                                        <Chip
                                            key={index}
                                            label={value}
                                            clickable
                                            // color="primary"
                                            variant="contained"
                                            deleteIcon={
                                                <CancelIcon
                                                    onMouseDown={(e) => {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                    }}
                                                />
                                            }
                                            onDelete={(e) => handleDelete(e, value)}
                                        />
                                    ) : (
                                        <div>{index < 2 ? <div>+ {displayItem}</div> : null}</div>
                                    )}
                                </div>
                            ))}
                        </Box>
                    )}
                >
                    <MenuItem onClick={handleSelectAll}>
                        <Checkbox checked={selectAll} />
                        <ListItemText primary="Select All" />
                    </MenuItem>
                    <ListSubheader>
                        <TextField
                            size="small"
                            inputRef={textInput}
                            placeholder=""
                            //fullWidth
                            value={searchText}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    /*close icon to clear the search text*/
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setSearchText("")}>
                                            <CloseIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            onChange={(e) => handleInputChange(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                    // Prevents autoselecting item while typing (default Select behaviour)
                                    e.stopPropagation();
                                }
                            }}
                        />
                    </ListSubheader>
                    {namesData?.map((name, index) => (
                        <MenuItem key={index + name} value={name}>
                            {selectAll ? <Checkbox onChange={(e) => handleChange(e, name)}
                                checked={columnName.some((o) => o === name)}
                            /> :
                                <Checkbox onChange={(e) => handleChange(e, name)}
                                checked={columnName.indexOf(name) > -1} />}
                            <ListItemText primary={name} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    )
}

export default MultiSelectColumns